const locale = require('./changeProducts.i18n.json');

/*@ngInject*/
const ChangeProductsModalController = function ($rootScope, $scope, options, coreMediator, preferenceModel, coreConstant) {

    $scope.i18n = locale;
    $scope.title = _.get($scope.i18n, 'title');
    $scope.cancelButton = _.get($scope.i18n, 'cancel');
    $scope.okButton = _.get($scope.i18n, 'createQuote');

    $scope.viewModel = {
        selectedProducts: _.split(options.selectedProducts, ','),
        savedSelectedProducts: _.split(options.selectedProducts, ',')
    };

    $scope.isChecked = function (name) {
        return (_.indexOf($scope.viewModel.selectedProducts, name) === -1) ? false : true;
    };

    $scope.canEnableConfirmButton = function () {
        return !_.isEqual($scope.viewModel.selectedProducts.sort(), $scope.viewModel.savedSelectedProducts.sort()) &&
            $scope.viewModel.selectedProducts.length !== 0;
    };

    function isProductRemoved() {
        let isProductRemoved = false;
        _.each($scope.viewModel.savedSelectedProducts, (product) => {
           if (!$scope.viewModel.selectedProducts.includes(product)){
               isProductRemoved = true;
           }
        });
        return isProductRemoved;
    };

    $scope.handleClick = function (changeProduct) {
        if (changeProduct.checked) {
            $scope.viewModel.selectedProducts.push(changeProduct.value);
        } else {
            _.pull($scope.viewModel.selectedProducts, changeProduct.value);
        }
    };

    $scope.onConfirm = function () {
        $scope.$close({
            productShortNames: _.join($scope.viewModel.selectedProducts, ','),
            isProductRemoved: isProductRemoved()
        });
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    function getAuthorizedProducts() {
        var dynamicDataSetParams = {
            name: 'User Authorized Products',
            submissionUri: 'com.firstbest.underwriting.submission.Submission:' + options.submissionId
        };

        coreMediator.getDynamicDataSetItems(dynamicDataSetParams).then(function (response) {
            _.each(response, (product) => {
                product.checked = $scope.isChecked(product.value);
            });
            $scope.viewModel.authorizedProducts = response;
        });
    }

    getAuthorizedProducts();

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('changeProductsModalController', ChangeProductsModalController);
